import React from 'react';
import { VignetteProps } from '../types';

const keyframes = `
@keyframes shepherdDoqSlide {
  0% { left: 54px; transform: translateY(-26px) rotate(0); }
  50% { transform: translateY(-38px) rotate(5deg); }
  100% { left: calc(100% - 96px); transform: translateY(-26px) rotate(0); }
}
@keyframes shepherdTrail {
  0% { transform: scaleX(0); opacity: 0; }
  40% { opacity: 1; }
  100% { transform: scaleX(1); opacity: .25; }
}
`;

const avatarStyle = (side: 'left' | 'right', bg: string, size: number): React.CSSProperties => ({
  position: 'absolute',
  top: '50%',
  [side]: 14,
  width: size,
  height: size,
  marginTop: -size / 2,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#fff',
  fontWeight: 700,
  fontSize: 15,
  border: '2px solid #fff',
  boxShadow: '0 4px 12px rgba(24,0,100,.3)',
  background: bg,
});

// How much clear space below the card the panel needs to sit comfortably;
// below that, flip to placing it above the card instead.
const MIN_SPACE_BELOW_CARD = 130;

const ShareHandoff: React.FC<VignetteProps> = ({ targetRect, cardRect, reduced }) => {
  if (!targetRect) return null;

  // Item E: when the card has measured, place the panel in the free space
  // around it (below by default, above if there isn't room) instead of
  // overlaying the target rect - which the card itself usually sits on top
  // of, hiding the panel behind it. Falls back to the original
  // target-anchored placement until the card measures.
  const panelStyle: React.CSSProperties = cardRect
    ? (() => {
      const width = Math.min(320, window.innerWidth - 24);
      const left = Math.max(12, (window.innerWidth - width) / 2);
      const cardBottom = cardRect.top + cardRect.height;
      const spaceBelow = window.innerHeight - cardBottom;
      const below = spaceBelow >= MIN_SPACE_BELOW_CARD;
      return {
        left,
        width,
        height: 110,
        ...(below
          ? { top: cardBottom + 20 }
          : { bottom: window.innerHeight - cardRect.top + 20 }),
      };
    })()
    : {
      left: Math.max(12, targetRect.left + 8),
      width: Math.min(320, targetRect.width - 16),
      top: targetRect.top + 8,
      height: 96,
    };
  const avatarSize = cardRect ? 46 : 42;

  return (
    <div
      style={{
        position: 'fixed',
        ...panelStyle,
        borderRadius: 14,
        background: 'rgba(237,233,241,.96)',
        boxShadow: '0 8px 24px rgba(24,0,100,.25)',
        pointerEvents: 'none',
        overflow: 'hidden',
        fontFamily: 'Grift, sans-serif',
      }}
      aria-hidden="true"
    >
      <style>{keyframes}</style>
      <div style={avatarStyle('left', 'linear-gradient(144deg,#AB72ED,#744DA1)', avatarSize)}>D</div>
      <div style={avatarStyle('right', 'linear-gradient(144deg,#EC4A85,#8E2C4E)', avatarSize)}>M</div>
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: 70,
          right: 70,
          height: 3,
          marginTop: -1,
          background: 'linear-gradient(90deg, rgba(171,114,237,0), rgba(171,114,237,.8), rgba(229,22,197,.6))',
          borderRadius: 100,
          transformOrigin: 'left',
          animation: reduced ? 'none' : 'shepherdTrail 1.5s ease-out .4s both',
          opacity: reduced ? 0.25 : undefined,
          transform: reduced ? 'scaleX(1)' : undefined,
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: reduced ? 'calc(100% - 96px)' : 54,
          width: 40,
          height: 50,
          marginTop: -26,
          background: '#fff',
          border: '1px solid #CDAAF4',
          borderRadius: 8,
          boxShadow: '0 4px 14px rgba(171,114,237,.5)',
          padding: '7px 6px 0',
          transform: reduced ? 'translateY(-26px) rotate(0)' : undefined,
          animation: reduced ? 'none' : 'shepherdDoqSlide 1.5s cubic-bezier(.4,0,.2,1) .4s both',
        }}
      >
        <div
          style={{
            height: 4, borderRadius: 2, background: '#E6E1EB', marginBottom: 5,
          }}
        />
        <div
          style={{
            height: 4, borderRadius: 2, background: '#E6E1EB', marginBottom: 5,
          }}
        />
        <div
          style={{
            height: 4, borderRadius: 2, background: '#E6E1EB', width: 14,
          }}
        />
      </div>
    </div>
  );
};

export default ShareHandoff;
